<template>
  <transition>
    <div
      ref="floatingBall"
      class="floating-ball-box"
      @click="clickFloatingBall"
      :style="{
        width: itemWidth * dpr + 'px',
        height: itemHeight * dpr + 'px',
        left: left + 'px',
        top: top + 'px',
      }"
    >
      <slot />
    </div>
  </transition>
</template>
 
<script>
export default {
	props: {
		itemWidth: {
			// 悬浮按钮宽度
			type: Number,
			default: 60,
		},
		itemHeight: {
			// 悬浮按钮高度
			type: Number,
			default: 60,
		},
		gapWidth: {
			// 距离左右两边距离
			type: Number,
			default: 12,
		},
		gapBottomHeight: {
			// 距离底部距离
			type: Number,
			default: 60,
		},
		coefficientHeight: {
			// 从上到下距离比例
			type: Number,
			default: 0.68,
		},
	},
	data() {
		return {
			top: 0, // 悬浮球距离可视区域顶部距离
			left: 0, // 悬浮球距离可视区域左边距离
			clientWidth: document.documentElement.clientWidth, // 可视区域宽度
			clientHeight: document.documentElement.clientHeight, // 可视区域高度
			dpr: document.documentElement.clientWidth / 375, // 设备像素比
		};
	},
	created() {
		this.left = this.clientWidth - (this.itemWidth + this.gapWidth) * this.dpr;
		this.top = this.clientHeight * this.coefficientHeight;
	},
	mounted() {
		this.$nextTick(() => {
			const floatingBall = this.$refs.floatingBall;
      // 手指按下
			floatingBall.addEventListener('touchstart', () => {
				floatingBall.style.transition = 'none';
			});
			// 拖拽
			floatingBall.addEventListener('touchmove', (e) => {
        e.preventDefault();
				if (e.targetTouches.length === 1) {
					const itemWidth = this.itemWidth * this.dpr;
					const itemHeight = this.itemHeight * this.dpr;
					const gapWidth = this.gapWidth * this.dpr;
					const gapBottomHeight = this.gapBottomHeight * this.dpr;
					// 一根手指
					let touch = e.targetTouches[0];
          const left = touch.clientX - itemWidth / 2;
          const top = touch.clientY - itemHeight / 2;
          const maxLeft = this.clientWidth - itemWidth - gapWidth;
          const maxTop = this.clientHeight - gapBottomHeight - itemHeight;
          // 处理边界
					this.left = left < gapWidth ? gapWidth : left > maxLeft ? maxLeft : left;
					this.top = top < 0 ? 0 : top > maxTop ? maxTop : top;
				}
			});
			// 拖拽结束，调整组件位置并设置过渡动画
			floatingBall.addEventListener('touchend', () => {
				const itemWidth = this.itemWidth * this.dpr;
				const gapWidth = this.gapWidth * this.dpr;
				floatingBall.style.transition = 'all 0.3s';
				if (this.left > (this.clientWidth - itemWidth) / 2) {
          // 居右
					this.left = this.clientWidth - itemWidth - gapWidth;
				} else {
          // 居左
					this.left = gapWidth;
				}
			});
		});
	},
	methods: {
		// 点击悬浮球
		clickFloatingBall() {
			this.$emit('click');
		},
	},
};
</script>
 
<style lang="scss" scoped>
  .floating-ball-box {
    position: fixed;
    z-index: 9;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
  }
</style>